<template>
  <img
    src="/assets/images/svg/CitSci_icon_BW.svg"
    alt="CitSci Project"
    class="citsci-project-icon"
    :style="iconStyle"
  >
</template>

<script>
export default {
  name: 'CitSciProjectIcon',
  props: {
    size: {
      type: String,
      default: '1x',
      validator: (value) => ['1x', '2x', '3x', '4x', '5x'].includes(value)
    }
  },
  computed: {
    iconStyle() {
      // Font Awesome base size is ~1em, fa-3x = 3em ~ 48px at 16px base
      const multiplier = parseInt(this.size);
      const sizeEm = `${multiplier}em`;
      return {
        width: sizeEm,
        height: sizeEm
      };
    }
  }
}
</script>

<style scoped>
.citsci-project-icon {
  display: inline-block;
  vertical-align: middle;
}
</style>
